module.exports = __webpack_public_path__ + "img/siscontrol_agenda_hero.3d70850d.svg";